
import { Mail, Phone, MapPin } from 'lucide-react';
import logo from "../../../../../../assets/windTree/images/login/logowbg.webp";
import { FaFacebookF, FaInstagram, FaXTwitter, FaWhatsapp } from "react-icons/fa6";

const Footer = () => {
  return (
    <>

      <footer className="bg-[#F0EDED] text-[#661E33]">
        <div className="max-w-full mx-auto px-4 sm:px-6 lg:px-8 pt-11">
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-8">
            {/* Company Info */}
            <div className="space-y-6">
              <img src={logo}
                // width="64"
                // height="64"
                loading="lazy"
                alt="Wind tree"
                className="h-16 rounded-md " />
              <p className="text-[#661e33] leading-relaxed">
                Transform your home with our premium custom blinds, shutters, and window treatments.
                Quality craftsmanship meets exceptional service.
              </p>
              <div className="flex space-x-4">
                <a
                  href="https://www.facebook.com/share/1CQXi5hMkr/"
                  aria-label="Visit our Facebook page"
                  target='_blank'
                  className="bg-white border p-2 rounded-lg hover:bg-blue-600 transition-colors focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2"
                >
                  <FaFacebookF className="w-5 h-5" aria-hidden="true" />
                </a>

                <a
                  href="https://x.com/"
                  aria-label="Visit our Twitter profile"
                  target="_blank"
                  className="bg-white border p-2 rounded-lg hover:bg-blue-600 transition-colors focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2"
                >
                  <FaXTwitter className="w-5 h-5" aria-hidden="true" />
                </a>

                <a
                  href="https://www.instagram.com/umbrona_designs?stkn=MzMyMHU5dHRnejAz"
                  aria-label="Visit our Instagram profile"
                  target="_blank"
                  className="bg-white border p-2 rounded-lg hover:bg-blue-600 transition-colors focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2"
                >
                  <FaInstagram className="w-5 h-5" aria-hidden="true" />
                </a>

                <a
                  href="https://web.whatsapp.com/"
                  aria-label="Visit our WhatsApp group"
                  target="_blank"
                  className="bg-white border p-2 rounded-lg hover:bg-blue-600 transition-colors focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2"
                >
                  <FaWhatsapp className="w-5 h-5" aria-hidden="true" />
                </a>
              </div>
            </div>



            {/* Services */}
            <div>
              <h4 className="text-lg font-semibold mb-6">Quick Links</h4>
              <ul className="space-y-3 ps-0">
                <li><a href="/home" className="text-[#661e33] hover:text-[#661e33] transition-colors">Home</a></li>
                <li><a href="#/about-us" className="text-[#661e33] hover:text-[#661e33] transition-colors">About Us</a></li>
                <li><a href="#/shop" className="text-[#661e33] hover:text-[#661e33] transition-colors">Shop</a></li>
                {/* <li><a href="#/blog" className="text-[#661e33] hover:text-[#661e33] transition-colors">Blog</a></li> */}
                <li><a href="#/contact-us" className="text-[#661e33] hover:text-[#661e33] transition-colors">Contact Us</a></li>
                <li><a href="#/productpage" className="text-[#661e33] hover:text-[#661e33] transition-colors">Our Products</a></li>


              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="text-lg font-semibold mb-6">Contact Us</h4>
              <div className="space-y-4">
                <a href="tel:+919872209400" className="flex items-center hover:opacity-80 transition-opacity">
                  <Phone className="w-5 h-5 text-[#66944b] mr-3 shrink-0" />
                  <span className="text-[#661e33]">  +91 9872209400</span>
                </a>
                <a
                  href="https://mail.google.com/mail/?view=cm&fs=1&to=nitin@wintree.in"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center hover:opacity-80 transition-opacity"
                >
                  <Mail className="w-5 h-5 text-[#66944b] mr-3 shrink-0" />
                  <span className="text-[#661e33]"> nitin@wintree.in</span>
                </a>
                <a
                  href="https://www.google.com/maps/search/?api=1&query=PLOT+NO.+4,+BHAGWANPUR+INDUSTRIAL+PARK,+DERABASSI-BARWALA+ROAD+,+DERABASSI,+PUNJAB+140507,+INDIA"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-start hover:opacity-80 transition-opacity"
                >
                  <MapPin className="w-5 h-5 text-[#66944b] mr-3 mt-1 shrink-0" />
                  <span className="text-[#661e33]">
                    PLOT NO. 4, BHAGWANPUR INDUSTRIAL PARK,
                    <br />DERABASSI-BARWALA ROAD ,
                    <br />DERABASSI, PUNJAB 140507,
                    <br />INDIA
                  </span>
                </a>
              </div>
            </div>
          </div>

          {/* Bottom bar */}
<div className="border-t border-[#DDD4D4] mt-4 py-3">            <div className="flex flex-col md:flex-row justify-between items-center">
<p className="text-[#7A6D6D] text-sm">                © 2025 Umbrona Designs. All rights reserved.
              </p>
              <div className="flex space-x-6 mt-2 md:mt-0">
                <a href="#" className="text-[#7A6D6D] hover:text-[#661E33] text-sm transition-colors">Privacy Policy</a>
                <a href="#" className="text-[#7A6D6D] hover:text-[#661E33] text-sm transition-colors">Terms of Service</a>
                {/* <a href="#" className="text-slate-400 hover:text-[#661e33] text-sm transition-colors">Cookie Policy</a> */}
                {/* <a href="#" className="text-slate-400 hover:text-[#661e33] text-sm transition-colors">Sitemap</a> */}
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;